import StatBar from '@components/stats/StatBar'
import React from 'react'
import styled from 'styled-components'

const StatsWrapper = styled.div`
  width: 100%;
  padding: 1rem;
`
const Meter = styled.div`
  position: relative;
  border-radius: ${({ theme }) => theme.borderRadius * 4}px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 1rem;
  &:last-child {
    margin-bottom: 0;
  }
`
const StatName = styled.div`
  width: 70px;
  text-transform: capitalize;
`

const StatsProvider = ({ stats }) => {
  const tifOptions = Object.keys(stats).map(key => {
    if (key === 'id') return null
    return (
      <Meter key={`${key}_${stats[key]}`}>
        <StatName>{key}</StatName>
        <StatBar value={stats[key] || 0} />
      </Meter>
    )
  })
  return <StatsWrapper>{tifOptions}</StatsWrapper>
}

export default StatsProvider
